import { IHttpClient } from '@wix/yoshi-flow-editor';
import { queryServices } from '@wix/ambassador-bookings-services-v2-service/http';
import {
  QueryServicesResponse,
  SortOrder,
} from '@wix/ambassador-bookings-services-v2-service/types';
import applicationJson from '../../../../../.application.json';
import { State } from '../state/state';
import { AsyncComponentDataStatus } from '../../types';

export const SERVICES_PAGE_SIZE = 100;

export const getServices = async (
  httpClient: IHttpClient,
  {
    selectedServices,
    limit,
    offset,
  }: { selectedServices?: string[]; limit?: number; offset?: number } = {},
): Promise<QueryServicesResponse> => {
  const sort = [
    {
      fieldName: 'category.sortOrder',
      order: SortOrder.ASC,
    },
    {
      fieldName: 'sortOrder',
      order: SortOrder.ASC,
    },
  ];
  const response = await httpClient.request(
    queryServices({
      query: {
        sort,
        filter: {
          ...(selectedServices?.length
            ? { id: { $in: selectedServices } }
            : null),
          appId: applicationJson.appDefinitionId,
        },
        paging: {
          limit: limit ?? SERVICES_PAGE_SIZE,
          offset: offset ?? 0,
        },
      },
    }),
  );

  return response.data;
};

export const getServicesIds = (services: State['services']): string[] => {
  if (services.status === AsyncComponentDataStatus.IDLE) {
    return services.data.services.map((service) => service.id!);
  } else {
    return [];
  }
};
